import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Time Tracking
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type TimetrackingParameters = TimetrackingTimeCreatedParameters | TimetrackingTimeDeletedParameters | TimetrackingTimeUpdatedParameters | TimetrackingWorktypeCreatedParameters | TimetrackingWorktypeDeletedParameters | TimetrackingDashboardFilterAssigneesSelectedParameters | TimetrackingDashboardFilterProjectsSelectedParameters | TimetrackingDashboardFilterWorktypeSelectedParameters | TimetrackingDashboardFilterPredefineddateSelectedParameters | TimetrackingDashboardFilterCustomdateSelectedParameters | TimetrackingDashboardBasicuserpromotionSelectedParameters | TimetrackingDashboardInitialupgradepromotionSelectedParameters;
export type TimetrackingEvents = TimetrackingTimeCreatedEvent | TimetrackingTimeDeletedEvent | TimetrackingTimeUpdatedEvent | TimetrackingWorktypeCreatedEvent | TimetrackingWorktypeDeletedEvent | TimetrackingDashboardFilterAssigneesSelectedEvent | TimetrackingDashboardFilterProjectsSelectedEvent | TimetrackingDashboardFilterWorktypeSelectedEvent | TimetrackingDashboardFilterPredefineddateSelectedEvent | TimetrackingDashboardFilterCustomdateSelectedEvent | TimetrackingDashboardBasicuserpromotionSelectedEvent | TimetrackingDashboardInitialupgradepromotionSelectedEvent;

export interface TimetrackingTimeCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	trackedTimeId: string; // ID of the tracked time entity
	context: string; // the type of time tracking: "clock", "self-input", "live-tracking"
}

export type TimetrackingTimeCreatedParametersSpecific = Omit<
	TimetrackingTimeCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingTimeCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingTimeCreatedEventBuilder {
	constructor(private specificParameters: TimetrackingTimeCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingTimeCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingTimeCreatedParametersSpecific,
            TimetrackingTimeCreatedParameters,
			(params: TimetrackingTimeCreatedParameters) => TimetrackingTimeCreatedEvent
		>(this.specificParameters, timetrackingTimeCreatedParametersGlobal, globalParams, (params) => new TimetrackingTimeCreatedEvent(params));
	}
}

/**
 * A user created a new time tracking time entry.
 */
export class TimetrackingTimeCreatedEvent extends CraftnoteEvent<TimetrackingTimeCreatedParameters>{
  constructor(parameters: TimetrackingTimeCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTracking_clockSave_succeeded"
		},
		{
			name: "iterable",
			eventName: "timetracking_time_created"
		},
	]);
  }
}
export interface TimetrackingTimeDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	trackedTimeId: string; // ID of the tracked time entity
}

export type TimetrackingTimeDeletedParametersSpecific = Omit<
	TimetrackingTimeDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingTimeDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingTimeDeletedEventBuilder {
	constructor(private specificParameters: TimetrackingTimeDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingTimeDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingTimeDeletedParametersSpecific,
            TimetrackingTimeDeletedParameters,
			(params: TimetrackingTimeDeletedParameters) => TimetrackingTimeDeletedEvent
		>(this.specificParameters, timetrackingTimeDeletedParametersGlobal, globalParams, (params) => new TimetrackingTimeDeletedEvent(params));
	}
}

/**
 * A user deleted a time tracking time entry.
 */
export class TimetrackingTimeDeletedEvent extends CraftnoteEvent<TimetrackingTimeDeletedParameters>{
  constructor(parameters: TimetrackingTimeDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTracking_deleteEntry_succeeded"
		},
		{
			name: "iterable",
			eventName: "timetracking_time_deleted"
		},
	]);
  }
}
export interface TimetrackingTimeUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	trackedTimeId: string; // ID of the tracked time entity
}

export type TimetrackingTimeUpdatedParametersSpecific = Omit<
	TimetrackingTimeUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingTimeUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingTimeUpdatedEventBuilder {
	constructor(private specificParameters: TimetrackingTimeUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingTimeUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingTimeUpdatedParametersSpecific,
            TimetrackingTimeUpdatedParameters,
			(params: TimetrackingTimeUpdatedParameters) => TimetrackingTimeUpdatedEvent
		>(this.specificParameters, timetrackingTimeUpdatedParametersGlobal, globalParams, (params) => new TimetrackingTimeUpdatedEvent(params));
	}
}

/**
 * A user updated a time tracking time entry.
 */
export class TimetrackingTimeUpdatedEvent extends CraftnoteEvent<TimetrackingTimeUpdatedParameters>{
  constructor(parameters: TimetrackingTimeUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTracking_editEntry_succeeded"
		},
		{
			name: "iterable",
			eventName: "timetracking_time_updated"
		},
	]);
  }
}
export interface TimetrackingWorktypeCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TimetrackingWorktypeCreatedParametersSpecific = Omit<
	TimetrackingWorktypeCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingWorktypeCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingWorktypeCreatedEventBuilder {
	constructor(private specificParameters: TimetrackingWorktypeCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingWorktypeCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingWorktypeCreatedParametersSpecific,
            TimetrackingWorktypeCreatedParameters,
			(params: TimetrackingWorktypeCreatedParameters) => TimetrackingWorktypeCreatedEvent
		>(this.specificParameters, timetrackingWorktypeCreatedParametersGlobal, globalParams, (params) => new TimetrackingWorktypeCreatedEvent(params));
	}
}

/**
 * A user created a new work type.
 */
export class TimetrackingWorktypeCreatedEvent extends CraftnoteEvent<TimetrackingWorktypeCreatedParameters>{
  constructor(parameters: TimetrackingWorktypeCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTracking_workTypeAdd_succeeded"
		},
		{
			name: "iterable",
			eventName: "timetracking_worktype_created"
		},
	]);
  }
}
export interface TimetrackingWorktypeDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TimetrackingWorktypeDeletedParametersSpecific = Omit<
	TimetrackingWorktypeDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingWorktypeDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingWorktypeDeletedEventBuilder {
	constructor(private specificParameters: TimetrackingWorktypeDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingWorktypeDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingWorktypeDeletedParametersSpecific,
            TimetrackingWorktypeDeletedParameters,
			(params: TimetrackingWorktypeDeletedParameters) => TimetrackingWorktypeDeletedEvent
		>(this.specificParameters, timetrackingWorktypeDeletedParametersGlobal, globalParams, (params) => new TimetrackingWorktypeDeletedEvent(params));
	}
}

/**
 * A user deleted a work type.
 */
export class TimetrackingWorktypeDeletedEvent extends CraftnoteEvent<TimetrackingWorktypeDeletedParameters>{
  constructor(parameters: TimetrackingWorktypeDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTracking_workTypeDelete_succeeded"
		},
		{
			name: "iterable",
			eventName: "timetracking_worktype_deleted"
		},
	]);
  }
}
export interface TimetrackingDashboardFilterAssigneesSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	count: number; // the number of assignees selected
}

export type TimetrackingDashboardFilterAssigneesSelectedParametersSpecific = Omit<
	TimetrackingDashboardFilterAssigneesSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardFilterAssigneesSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardFilterAssigneesSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardFilterAssigneesSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardFilterAssigneesSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardFilterAssigneesSelectedParametersSpecific,
            TimetrackingDashboardFilterAssigneesSelectedParameters,
			(params: TimetrackingDashboardFilterAssigneesSelectedParameters) => TimetrackingDashboardFilterAssigneesSelectedEvent
		>(this.specificParameters, timetrackingDashboardFilterAssigneesSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardFilterAssigneesSelectedEvent(params));
	}
}

/**
 * A user applied the assignees filter.
 */
export class TimetrackingDashboardFilterAssigneesSelectedEvent extends CraftnoteEvent<TimetrackingDashboardFilterAssigneesSelectedParameters>{
  constructor(parameters: TimetrackingDashboardFilterAssigneesSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_assigneeNumber_fil"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_filter_assignees_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardFilterProjectsSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	count: number; // the number of projects selected
}

export type TimetrackingDashboardFilterProjectsSelectedParametersSpecific = Omit<
	TimetrackingDashboardFilterProjectsSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardFilterProjectsSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardFilterProjectsSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardFilterProjectsSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardFilterProjectsSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardFilterProjectsSelectedParametersSpecific,
            TimetrackingDashboardFilterProjectsSelectedParameters,
			(params: TimetrackingDashboardFilterProjectsSelectedParameters) => TimetrackingDashboardFilterProjectsSelectedEvent
		>(this.specificParameters, timetrackingDashboardFilterProjectsSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardFilterProjectsSelectedEvent(params));
	}
}

/**
 * A user applied the projects filter.
 */
export class TimetrackingDashboardFilterProjectsSelectedEvent extends CraftnoteEvent<TimetrackingDashboardFilterProjectsSelectedParameters>{
  constructor(parameters: TimetrackingDashboardFilterProjectsSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_projectNumber_filt"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_filter_projects_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardFilterWorktypeSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	count: number; // the number of work types selected
}

export type TimetrackingDashboardFilterWorktypeSelectedParametersSpecific = Omit<
	TimetrackingDashboardFilterWorktypeSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardFilterWorktypeSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardFilterWorktypeSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardFilterWorktypeSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardFilterWorktypeSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardFilterWorktypeSelectedParametersSpecific,
            TimetrackingDashboardFilterWorktypeSelectedParameters,
			(params: TimetrackingDashboardFilterWorktypeSelectedParameters) => TimetrackingDashboardFilterWorktypeSelectedEvent
		>(this.specificParameters, timetrackingDashboardFilterWorktypeSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardFilterWorktypeSelectedEvent(params));
	}
}

/**
 * A user applied the work type filter.
 */
export class TimetrackingDashboardFilterWorktypeSelectedEvent extends CraftnoteEvent<TimetrackingDashboardFilterWorktypeSelectedParameters>{
  constructor(parameters: TimetrackingDashboardFilterWorktypeSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_workTypeNumber_fil"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_filter_worktype_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardFilterPredefineddateSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	type: string; // the type of date filter selected, must be one of "last-month", "last-week", "yesterday", "today"
}

export type TimetrackingDashboardFilterPredefineddateSelectedParametersSpecific = Omit<
	TimetrackingDashboardFilterPredefineddateSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardFilterPredefineddateSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardFilterPredefineddateSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardFilterPredefineddateSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardFilterPredefineddateSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardFilterPredefineddateSelectedParametersSpecific,
            TimetrackingDashboardFilterPredefineddateSelectedParameters,
			(params: TimetrackingDashboardFilterPredefineddateSelectedParameters) => TimetrackingDashboardFilterPredefineddateSelectedEvent
		>(this.specificParameters, timetrackingDashboardFilterPredefineddateSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardFilterPredefineddateSelectedEvent(params));
	}
}

/**
 * A user applied a pre-defined date filter.
 */
export class TimetrackingDashboardFilterPredefineddateSelectedEvent extends CraftnoteEvent<TimetrackingDashboardFilterPredefineddateSelectedParameters>{
  constructor(parameters: TimetrackingDashboardFilterPredefineddateSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_dateFilter_click"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_filter_predefineddate_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardFilterCustomdateSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	startDate: number; // the entered start date as seconds since UNIX epoch
	endDate: number; // the entered end date as seconds since UNIX epoch
}

export type TimetrackingDashboardFilterCustomdateSelectedParametersSpecific = Omit<
	TimetrackingDashboardFilterCustomdateSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardFilterCustomdateSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardFilterCustomdateSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardFilterCustomdateSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardFilterCustomdateSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardFilterCustomdateSelectedParametersSpecific,
            TimetrackingDashboardFilterCustomdateSelectedParameters,
			(params: TimetrackingDashboardFilterCustomdateSelectedParameters) => TimetrackingDashboardFilterCustomdateSelectedEvent
		>(this.specificParameters, timetrackingDashboardFilterCustomdateSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardFilterCustomdateSelectedEvent(params));
	}
}

/**
 * A user applied a custom date filter.
 */
export class TimetrackingDashboardFilterCustomdateSelectedEvent extends CraftnoteEvent<TimetrackingDashboardFilterCustomdateSelectedParameters>{
  constructor(parameters: TimetrackingDashboardFilterCustomdateSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_dateFilterCustom_r"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_filter_customdate_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardBasicuserpromotionSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TimetrackingDashboardBasicuserpromotionSelectedParametersSpecific = Omit<
	TimetrackingDashboardBasicuserpromotionSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardBasicuserpromotionSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardBasicuserpromotionSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardBasicuserpromotionSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardBasicuserpromotionSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardBasicuserpromotionSelectedParametersSpecific,
            TimetrackingDashboardBasicuserpromotionSelectedParameters,
			(params: TimetrackingDashboardBasicuserpromotionSelectedParameters) => TimetrackingDashboardBasicuserpromotionSelectedEvent
		>(this.specificParameters, timetrackingDashboardBasicuserpromotionSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardBasicuserpromotionSelectedEvent(params));
	}
}

/**
 * A user clicked on the upgrade button in the basic user promotion dialog.
 */
export class TimetrackingDashboardBasicuserpromotionSelectedEvent extends CraftnoteEvent<TimetrackingDashboardBasicuserpromotionSelectedParameters>{
  constructor(parameters: TimetrackingDashboardBasicuserpromotionSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_basicUserPromotion"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_basicuserpromotion_selected"
		},
	]);
  }
}
export interface TimetrackingDashboardInitialupgradepromotionSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TimetrackingDashboardInitialupgradepromotionSelectedParametersSpecific = Omit<
	TimetrackingDashboardInitialupgradepromotionSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const timetrackingDashboardInitialupgradepromotionSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TimetrackingDashboardInitialupgradepromotionSelectedEventBuilder {
	constructor(private specificParameters: TimetrackingDashboardInitialupgradepromotionSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TimetrackingDashboardInitialupgradepromotionSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TimetrackingDashboardInitialupgradepromotionSelectedParametersSpecific,
            TimetrackingDashboardInitialupgradepromotionSelectedParameters,
			(params: TimetrackingDashboardInitialupgradepromotionSelectedParameters) => TimetrackingDashboardInitialupgradepromotionSelectedEvent
		>(this.specificParameters, timetrackingDashboardInitialupgradepromotionSelectedParametersGlobal, globalParams, (params) => new TimetrackingDashboardInitialupgradepromotionSelectedEvent(params));
	}
}

/**
 * A user clicked on the upgrade button in initial upgrade promotion.
 */
export class TimetrackingDashboardInitialupgradepromotionSelectedEvent extends CraftnoteEvent<TimetrackingDashboardInitialupgradepromotionSelectedParameters>{
  constructor(parameters: TimetrackingDashboardInitialupgradepromotionSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "timeTrackingDashboard_initialUpgradeDial"
		},
		{
			name: "iterable",
			eventName: "timetracking_dashboard_initialupgradepromotion_selected"
		},
	]);
  }
}
